import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'surveys',
  'upcoming-survey-completions',
  ['MESSAGE'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'upcoming_assignments',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['assignmentId'],
    },
    'completions',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/upcoming-survey-completions.js